import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ShortlistContext = createContext({ ids: [], toggle: () => {}, has: () => false, clear: () => {} });
const KEY = "cs_shortlist";

export const ShortlistProvider = ({ children }) => {
  const [ids, setIds] = useState([]);
  useEffect(() => {
    try { setIds(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { setIds([]); }
  }, []);
  const persist = (next) => { setIds(next); localStorage.setItem(KEY, JSON.stringify(next)); };
  const toggle = useCallback((id) => {
    const next = ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id];
    persist(next);
  }, [ids]);
  const has = useCallback((id) => ids.includes(id), [ids]);
  const clear = () => persist([]);
  return <ShortlistContext.Provider value={{ ids, toggle, has, clear }}>{children}</ShortlistContext.Provider>;
};

export const useShortlist = () => useContext(ShortlistContext);
